import React, { useEffect, useState, useContext } from "react";
import _ from "lodash";
import Form from "forms/Form";

import { ASSOCIATION, AWS_APPS, DOMAINS } from "api/config/endpoints";

import formWrapper from "hoc/formWrapper";

import { InlineNotification, Loading, Tag } from "carbon-components-react";
import useUser from "hooks/useUser";
import { consoleLog, getAppIdFormField } from "utils/functions";
import MainContext from "context/MainContext";

const CreateDomainAssociationForm = ({ onUpdateDomainName, ...props }) => {
    const {
        userIsSuperAdmin,
        userIsDev
    } = useUser()

    useEffect(() => {
        setDefaultValues(props.defaultValues)
    }, [props.defaultValues])
    const [errors, setErrors] = useState();
    const [report, setReport] = useState();
    const [loaded, setLoaded] = useState(true);
    const [saving, setSaving] = useState(false);
    const [defaultValues, setDefaultValues] = useState({});
    const context = useContext(MainContext)

    const getEndpoint = () => {
        return [
            AWS_APPS,
            DOMAINS,
            ASSOCIATION
        ].join("/")
    }

    const getValue = (name, type) => {
        const value = !_.isEmpty(defaultValues) ? defaultValues[name] : null;
        switch (type) {
            case "bool":
                return (value !== 0 && value !== null && value !== undefined);
            default:
                return value;
        }
    };

    const onSubmit = async (e) => {
        setReport()
        setErrors()
        consoleLog("client.get onSubmit", e)
        if (e) {
            setReport(["The domain association process has started for domain name " + getValue("domain_name")])
        }
        else {
            setErrors(["Something went wrong during the domain association. Please contact support"])
        }
        if (props.onSubmit) {
            window.setTimeout(() => {
                props.onSubmit(e)
            }, 500)
        }
    }

    let fields = [
        {
            elementType: "domain",
            id: "domain",
            name: "domain",
            invalidText: "This must be a valid domain (NO 'www'!!!)",
            labelText: "Domain",
            placeholder: "Domain",
            value: getValue("domain"),
            rules: {
                url: true,
                pattern:
                    "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$",
            },
        },


    ]

    if (props.hideAppId) {
        fields.push(getAppIdFormField({ isAdmin: false, getValue }))

    }
    else {
        fields.push(
            getAppIdFormField({ isAdmin: true, awsApps: props.awsApps, getValue })
        )
    }

    if (userIsSuperAdmin() && !props.hideBranch) {
        fields.push({
            elementType: "input",
            id: "branch",
            name: "branch",
            // invalidText: "Invalid error message.",
            labelText: "Branch (default is 'master')",
            placeholder: "master",
            value: getValue("branch"),
        })
    }

    fields.push({
        elementType: "input",
        id: "one_time_password",
        name: "one_time_password",
        labelText: "Insert your one time password",
        placeholder: "One time password",
        value: getValue("one_time_password"),
        rules: {
            required: true,
        },
    })

    const onChange = (key, value) => {
        if (key === "domain") {
            console.log("onChange fqdn", value.match(/^(?!\-)(?:(?:[a-zA-Z\d][a-zA-Z\d\-]{0,61})?[a-zA-Z\d]\.){1,126}(?!\d+)[a-zA-Z\d]{1,63}$/i))
            // setIsFqdn(value.match(/^(?!\-)(?:(?:[a-zA-Z\d][a-zA-Z\d\-]{0,61})?[a-zA-Z\d]\.){1,126}(?!\d+)[a-zA-Z\d]{1,63}$/i))
            if (onUpdateDomainName) {
                onUpdateDomainName(value)
            }
        }
        setDefaultValues({
            ...defaultValues,
            [key]: value
        });
    }

    const onSavingChange = (value) => {
        setSaving(value)
    }

    const defaultParams = () => {
        return {}
    }

    let extraContents = [];

    const domainName = getValue("domain")
    if (domainName) {
        if (report) {
            extraContents = [
                ...extraContents,
                ...report?.map(msg => <>{msg}</>)
            ]
            extraContents.push(
                <InlineNotification
                    kind="success"
                    hideCloseButton={true}
                    lowContrast={true}
                    title={"Registering " + domainName}
                    subtitle={report?.map(msg => <>{msg}</>)}
                />
            )
        }
    }

    return (
        <div className={props.className}>
            {
                saving ? <Loading /> : null
            }
            {
                // !userIsDev() ? (<div style={{ padding: "3rem 1rem" }}>
                //     <Tag type="red">You are not authorised to do this action, this operation is reserved for dev only</Tag>
                // </div>) :
                (
                    <Form
                        blockTouched={false}
                        // itemId={itemId}
                        fields={fields}
                        endpoint={getEndpoint()}
                        loaded={loaded}
                        modal={props.modal}
                        onRequestClose={props.onRequestClose}
                        onSavingChange={(value) => onSavingChange(value)}
                        // setAutoId={true}
                        // saveOnChange={true}
                        // hideSubmitButton={true}
                        onChange={(key, val) => onChange(key, val)}
                        defaultParams={defaultParams()}
                        onSubmit={(e) => onSubmit(e)}
                        primaryButtonText={"Confirm"}
                        extraFieldsAfter={extraContents}
                    // key={"form-" + itemId}
                    />
                )}
        </div>
    );
};

export default formWrapper(CreateDomainAssociationForm);
